import { css } from "styled-components";
export default css`
    .ant-select-dropdown .ant-select-item-option {
        &-active:not(.ant-select-item-option-disabled) {
            background-color: #AAD3701A;
        }
        &-selected:not(.ant-select-item-option-disabled) {
            background-color: #AAD3701A;
        }
    }
    .ant-select {
        &-focused.ant-select:not(.ant-select-disabled) .ant-select-selector {
            border-color: #AAD370 !important;
        }
        &:not(.ant-select-disabled):hover .ant-select-selector {
            border-color: #AAD370 !important;
        }
    }
`;